export function adjustSlideLeftPadding(carousel) {
  const slides = Array.from(carousel.querySelectorAll(".swiper-slide"));
  const wrapper = carousel.querySelector(".slide-show-carousel__wrapper");
  const header = carousel.getElementsByClassName("slide-show-carousel__header");

  slides.forEach((el, i) => {
    el.style.paddingLeft = `${
      header[0].getBoundingClientRect().left -
      wrapper.getBoundingClientRect().left
    }px`;
  });
}

export function resetSlideLeftPadding(carousel) {
  const slides = Array.from(carousel.querySelectorAll(".swiper-slide"));
  slides.forEach((el, i) => {
    el.style.paddingLeft = "0px";
  });
}
